import Vue from 'vue';

import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';
import Meta from 'vue-meta';

import Home from '../views/Home.vue';

Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(Meta);

const routes = [
    {
        path: '/',
        alias: '*',
        name: 'home',
        component: Home
    }
];

const router = new VueRouter({
    mode: 'history',

    base: process.env.BASE_URL,

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },

    routes
});

export default router;
